
export class ModalInfo {
    
    stateModalAlert: boolean;
    messageModal: string;
    type: string;
}

